import { css } from 'aphrodite';
import * as React from 'react';
import { useContext } from 'react';
import { ViewportContext } from '../../../hooks/useViewport';
import { ProgressBar } from '../../ProgressBar';
import { styleSheet } from '../styles';

export interface IDemosListRowItem {
	name?: string;
	label?: string;
	goal: number;
	demos: number;
}

interface IProps {
	label: string;
	total: IDemosListRowItem;
	rows: IDemosListRowItem[];
}

export const DemosList: React.FC<IProps> = ({ label, total, rows }) => {
	const { isBelowSmall } = useContext(ViewportContext);
	const showProgress = !isBelowSmall;

	return (
		<div className={css(styleSheet.demosTable)}>
			<div className={css(styleSheet.demosRow, styleSheet.demosHeaderRow)}>
				<span className={css(styleSheet.demosLabel)} title={label}>
					{label}
				</span>
				<span className={css(styleSheet.demosHeaderCell)}>Goal</span>
				<span className={css(styleSheet.demosHeaderCell)}>Actual</span>
				{showProgress ? <span className={css(styleSheet.demosProgressHeader)}>Progress</span> : null}
			</div>
			{rows.map(item => (
				<div className={css(styleSheet.demosRow)} key={item.name}>
					<span className={css(styleSheet.demosLabel)} title={item.label}>
						{item.label}
					</span>
					<span className={css(styleSheet.demosGoal)}>{item.goal}</span>
					<span className={css(styleSheet.demosActual)}>{item.demos}</span>
					{showProgress ? (
						<div className={css(styleSheet.demosProgress)}>
							<ProgressBar
								hideValues={true}
								isSmall={true}
								goal={item.goal}
								amount={item.demos}
								label={`${item.label} toward goal`}
							/>
						</div>
					) : null}
				</div>
			))}
			{total ? (
				<div className={css(styleSheet.demosRow, styleSheet.demosTotalRow)}>
					<span>Total</span>
					<span className={css(styleSheet.demosTotalCell)}>{total.goal}</span>
					<span className={css(styleSheet.demosTotalCell)}>{total.demos}</span>
					{showProgress ? (
						<div className={css(styleSheet.demosProgress)}>
							<ProgressBar
								hideValues={true}
								isSmall={true}
								goal={total.goal}
								amount={total.demos}
								label={`${label} total toward goal`}
							/>
						</div>
					) : null}
				</div>
			) : null}
		</div>
	);
};
